import { ServiceKey } from './SERVICE_KEYS';

// Простой DI контейнер
export class DIContainer {
  private static instance: DIContainer;
  private services: Map<ServiceKey, any> = new Map();
  private factories: Map<ServiceKey, () => any> = new Map();

  private constructor() {}

  static getInstance(): DIContainer {
    if (!DIContainer.instance) {
      DIContainer.instance = new DIContainer();
    }
    return DIContainer.instance;
  }

  // Регистрация сервиса как singleton
  register<T>(key: ServiceKey, service: T): void {
    this.services.set(key, service);
  }

  // Регистрация фабрики для создания сервиса
  registerFactory<T>(key: ServiceKey, factory: () => T): void {
    this.factories.set(key, factory);
  }

  // Получение сервиса
  resolve<T>(key: ServiceKey): T {
    // Сначала проверяем зарегистрированные сервисы
    if (this.services.has(key)) {
      return this.services.get(key);
    }

    // Затем проверяем фабрики
    if (this.factories.has(key)) {
      const factory = this.factories.get(key)!;
      const service = factory();
      this.services.set(key, service); // Кэшируем результат
      return service;
    }

    throw new Error(`Сервис с ключом '${key}' не зарегистрирован`);
  }

  // Проверка существования сервиса
  has(key: ServiceKey): boolean {
    return this.services.has(key) || this.factories.has(key);
  }

  // Очистка всех сервисов
  clear(): void {
    this.services.clear();
    this.factories.clear();
  }
}

// Экспорт singleton экземпляра
export const container = DIContainer.getInstance();

// Функция-помощник для получения сервиса
export function getService<T>(key: ServiceKey): T {
  return container.resolve<T>(key);
}
